<template>
  <reSelect
    ref="reSel"
    v-model="field"
    @select-search="inputSearch"
    @on-open-change="onOpenChange"
    @on-change="onChange"
    searchPlaceholder="请选择">
    <Option v-for="opt in realOpts" :value="opt.value" :key="opt.value">{{ opt.label }}</Option>
  </reSelect>
</template>
<script>
import reSelect from '@/components/reSelect/select'
import _ from 'underscore'
export default {
  name: 'filterSelect',
  components: { reSelect },
  props: {
    selectOptions: {
      type: Array,
      required: true
    },
    Index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      field: '',
      value: '' // 用来保存searchValue的值
    }
  },
  computed: {
    realOpts() {
      return this.selectOptions.filter(item => {
        return (item.label.indexOf(this.value) > -1)
      })
    }
  },
  watch: {
    $route() {
      this.field = ''
    }
  },
  methods: {
    closeDrop() {
      this.$refs.reSel.visible = false
    },
    inputSearch: _.debounce(function(value) {
      this.value = value
    }, 300, false),
    onOpenChange(val) {
      if (val) {
        this.$nextTick(() => { // 下拉置0
          this.$refs.reSel.$el.querySelector('.yjh-scroll').scrollTop = 0
        })
      }
      this.value = ''
    },
    onChange() {
      if (this.field !== undefined) {
        this.selectOptions.forEach(item => {
          if (item.value === this.field) {
            this.$emit('selectData', {
              index: this.Index,
              params: item
            })
          }
        })
      }
    }
  }
}
</script>
